<div class="modal-backdrop" *ngIf="isOpen" (click)="close()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="close()">×</button>

    <div class="modal-header">
      <div class="bell-icon">
        <i class="fa-regular fa-bell"></i>
      </div>
      <h3>{{ productName }} est en rupture</h3>
    </div>

    <p class="desc">
      Soyez le premier averti de son retour en stock ! Laissez-nous votre e-mail :
    </p>

    <form (submit)="submitEmail($event)">
      <div class="input-group">
        <input
          type="email"
          [(ngModel)]="email"
          name="email"
          placeholder="Votre adresse e-mail"
          required
          class="form-control">
        <button type="submit" class="btn-notify" [disabled]="loading || !email">
          <span *ngIf="!loading">M'avertir</span>
          <i class="fa fa-spinner fa-spin" *ngIf="loading"></i>
        </button>
      </div>
      <!-- Message format email invalide -->
      <p class="msg-error" *ngIf="emailInvalid">Format d'e-mail invalide (ex : john@ex.com)</p>
    </form>

    <p class="success-msg" *ngIf="msg && success">{{ msg }}</p>
    <p class="msg-error" *ngIf="msg && !success">{{ msg }}</p>
  </div>
</div>